export const add = (previous, parent, content) => {
    const currentMaxId = Math.max(...Object
        .keys(previous)
        .map((key) => parseInt(key, 10)));
    const { subTasks } = previous[parent];
    const nextId = currentMaxId + 1;
    return (Object.assign(Object.assign({}, previous), { [parent]: Object.assign(Object.assign({}, previous[parent]), { subTasks: [...subTasks, nextId] }), [nextId]: { main: content, subTasks: [] } }));
};
export const remove = (previous, target) => {
    const parent = Object.entries(previous).reduce((ret, [id, { subTasks }]) => {
        if (!subTasks.includes(target)) {
            return ret;
        }
        return id;
    }, -1);
    const { subTasks } = previous[parent];
    return (Object.assign(Object.assign({}, previous), { [parent]: Object.assign(Object.assign({}, previous[parent]), { subTasks: subTasks.filter((id) => id !== target) }), [target]: undefined }));
};
